/**
 * Add additional classes and wrap text for Buttons-columns section's buttons
 *
 * @param {}
 * @return {void}
 */

const $buttonsColumns = $('.buttons-columns');

if ($buttonsColumns.length !== 0) {
  const $button = $buttonsColumns.find('.shg-btn');
  const additionalClasses = 'btn btn--outline btn--file js-hover';
  const hoverInnerHTML = '<span class="btn__inner js-hover-inner"></span>';
  const wrapHTML = '<span class="btn__text"></span>'
  const svgHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 16 22"><defs><style>.a-file{fill:none;stroke:#000;stroke-linecap:round;stroke-width:2px;}</style></defs><g transform="translate(1 1)"><path class="a-file" d="M13,2H6V22H20V9Z" transform="translate(-6 -2)"/><path class="a-file" d="M13,2V9h7" transform="translate(-6 -2)"/></g></svg>';

  $button.each(function() {
    $(this)
      .addClass(additionalClasses)
      .prepend(svgHTML)
      .wrapInner(wrapHTML)
      .append(hoverInnerHTML);
  });
}

